import PropTypes from 'prop-types';
import ParticipantItemImpl from './participant-item.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Component that displays a participant's name with an optional team logo/icon.
 * Supports displaying short names when team logo is shown, and can optionally
 * display starting pitcher names for baseball events.
 *
 * @class ParticipantItem
 * @memberof Mojito.Presentation.Components
 */

/**
 * ParticipantItem prop types.
 *
 * @property {string} sportId - Sport id for team icon.
 * @property {object} participant - The participant.
 * @property {Function} [updateTeamValidIcons] - Callback for tracking team icon validity.
 * @property {boolean} [showTeamLogo = true] - Flag indicating whether to display the team logo.
 *
 * @memberof Mojito.Presentation.Components.ParticipantItem
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    participant: PropTypes.object.isRequired,
    updateTeamValidIcons: PropTypes.func,
    showTeamLogo: PropTypes.bool,
};

const defaultProps = {
    participant: {},
    updateTeamValidIcons: noop,
    showTeamLogo: true,
};

export default UIView('ParticipantItem', ParticipantItemImpl, propTypes, defaultProps);
